const resources = {
    aiSummaryTitle: 'AI Review Summary',
    aiDisclaimer: 'This summary was created using artificial intelligence (AI) from the text of recent customer reviews. Please review the "About the Product" section for the most accurate product information.',
    incentivizedNote: 'Some reviewers received something in exchange for a review (free product, payment, sweeps entry).',
    prosMentioned: 'Pros Mentioned',
    consMentioned: 'Cons Mentioned',
    noSummaryAvailable: 'Review summary is not available for this product.',
    fromCustomerReviews: 'From customer reviews:'
};

export default function getResource(label) {
    return resources[label];
}
